import React from "react";
import { Tooltip as MantineTooltip } from "@mantine/core";
const Tooltip = (props) => {
  return (
    <MantineTooltip
      openDelay={100}
      position="bottom"
      transition="scale"
      transitionDuration={300}
      style={{ background: "rgba(0, 0, 0, 0.70)" }}
      multiline
      withArrow
      {...props}
    >
      {props.children}
    </MantineTooltip>
  );
};

export default Tooltip;
